@if (isLoading) {
  <div>
    @if (isLoading) {
      <div class="container d-flex justify-content-center align-items-center m-auto spinner" [@fadeInOut]>
        <div>
          <div class="spinner-grow text-primary spinner-grow-sm m-1" role="status"></div>
          <div class="spinner-grow text-secondary spinner-grow-sm m-1" role="status"></div>
          <div class="spinner-grow text-success spinner-grow-sm m-1" role="status"></div>
          <div class='loader--text'></div>
        </div>
      </div>
    }
    @if (isLoading) {
      <div class="background" [@fadeInOut]></div>
    }
  </div>
}
